<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="offer manage">
          <div class="custom">
            <jm-toolbar
              ref="toolbarvm"
              customize-field-name="ActionGroup"
              show-defined-search
              show-defined-list
              size="small">
              <router-link
                slot="beforeDefinedSearch"
                class="button-search"
                target="_blank"
                :to="{ name: 'actionGroupEdit', params: { id: 0 } }">
                <el-button
                  type="primary"
                  size="medium">添加用户行为主题</el-button>
              </router-link>
            </jm-toolbar>
          </div>
          <div class="options">
            <el-form
              :model="searchData"
              inline>
              <jm-form-options
                :options="searchStructure"
                :option-data="searchData"
                :need-filter="true"
                :const-dict="options"/>
            </el-form>
          </div>
          <div class="operation">
            <el-button
              type="primary"
              :size="size"
              @click="getSearch">查询</el-button>
            <el-button
              type="primary"
              :size="size"
              @click="setSearchData">重置</el-button>
          </div>
          <jm-tableList
            url="/index/b_i_action_group/getPage"
            :refresh="refresh"
            :search-data="searchData"
            :current-page.sync="currentPage">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="180"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <a
                  :href="`/frontend/actionGroup/info/${scope.row.id}`"
                  v-if="checkUser(scope.row.view_userid, true)"
                  target="_blank"
                  title="查看详情"><el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-document">查看
                </el-button></a>
                <a
                  :href="`/frontend/actionGroup/edit/${scope.row.id}`"
                  v-if="checkUser(scope.row.view_userid, false)"
                  title="编辑"><el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit-outline">编辑
                </el-button></a>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

  .el-form {
    margin-top: 20px;
  }
  .button-search {
    margin-right: 10px;
    display: inline-block;
    height: 100%;
  }
  .offer.manage .operation {
    padding-bottom: 1em;
    text-align: center;
  }
  .offer.manage .options .el-form-item {
    display: -webkit-flex;
    display: flex;
    margin-bottom: 10px;
  }

  .offer.manage .options .el-form-item__label {
    min-width: 7em;
    padding-right: 8px;
  }
  .offer.manage .options .el-form-item__content {
    -webkit-flex: 1;
    flex: 1;
  }
  .offer.manage .options .el-date-editor--daterange.el-input,
  .offer.manage .options .el-date-editor--daterange.el-input__inner,
  .offer.manage .options .el-date-editor--timerange.el-input,
  .offer.manage .options .el-date-editor--timerange.el-input__inner {
    width: 100%;
    white-space: nowrap;
  }
</style>
<script>
import { mapGetters } from 'vuex';
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { jmDictSelect } from '@/components/tool';
import { filterVisible } from '@/utils/utils';
import jmFormOptions from '@/components/data/formOptions';
// 搜索项结构
const searchStructure = [
  {
    visible: 'id',
    field: 'id',
    label: '主题编号',
    placeholder: '主题编号',
    component: 'input',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'act_title',
    field: 'act_title',
    label: '主题名称',
    placeholder: '主题名称',
    component: 'input',
    column: [24, 12, 8, 8]
  }
];
  // options
const options = {
};
  // 搜索数据结构
const searchData = {
  act_remark: '',
  act_status: '',
  act_title: '',
  end_time: 0,
  id: '',
  star_time: ''
};

export default {
  components: {
    jmToolbar, jmTableList, jmDictSelect, jmFormOptions
  },
  data() {
    return {
      tableListInited: false,
      size: 'small',
      searchStructure,
      appOrder: 0,
      options,
      searchData: {},
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 监听状态刷新数据
    refresh() {
      return this.$store.state.student.refresh;
    },
  },
  methods: {
    filterVisible,
    // 初始默认搜索值
    setSearchData() {
      this.searchData = Object.assign({}, searchData);
    },
    getSearch() {
      this.currentPage = 1;
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
      this.$store.commit('updateRefresh', true);
    },
    // eslint-disable-next-line
    checkUser(viewUserid, check) {
      // console.log(this.$store.getters.userInfo.userid);
      // let userid = this.$store.getters.userInfo.userid;
      // let rs = (userid === 1);
      // if (check) {
      //   rs = viewUserid.indexOf(userid) > -1 || rs;
      // }
      // return rs;
      return true;
    }
  },
  created() {
    // 因为默认查询字段为空，初始设置查询数据字段
    this.setSearchData();
  },
  watch: {
  }
};
</script>
